import {
    getApplicationScreenshot,
    listApplicationScreenshots
} from './queries';
import {
    createApplicationScreenshot,
    updateApplicationScreenshot,
    retakeApplicationScreenshot,
    deleteApplicationScreenshot,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {ApplicationScreenshot, AuthenticationType} from "../types.ts";
import {screenshotsApiClient} from "../../screenshots-api-integration/client.ts";
import {fetchAuthSession} from "aws-amplify/auth";

const getAuthenticationInput = async () => {
    const {tokens} = await fetchAuthSession();
    if (tokens?.idToken && tokens?.accessToken) {
        return {
            type: AuthenticationType.COGNITO_IMPLICIT_FLOW,
            idToken: tokens.idToken.toString(),
            accessToken: tokens.accessToken.toString(),
        };
    }
    return undefined;
};


export type ListApplicationScreenshots = {
    listApplicationScreenshots: { items: ApplicationScreenshot[] }
}

export type GetApplicationScreenshot = {
    getApplicationScreenshot: ApplicationScreenshot
}

export type CreateApplicationScreenshot = {
    createApplicationScreenshot: ApplicationScreenshot
}

export type UpdateApplicationScreenshot = {
    updateApplicationScreenshot: ApplicationScreenshot
}

export type RetakeApplicationScreenshot = {
    retakeApplicationScreenshot: ApplicationScreenshot
}

export type DeleteApplicationScreenshot = {
    deleteApplicationScreenshot: string
}

const client = screenshotsApiClient;


export const fetchRecords = async (filter: object) => {
    const response = await client.graphql<GraphQLQuery<ListApplicationScreenshots>>({
                                                                              query: listApplicationScreenshots,
                                                                              variables: {filter: filter},
                                                                          });
    return response.data?.listApplicationScreenshots.items;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetApplicationScreenshot>>({
                                                                            query: getApplicationScreenshot,
                                                                            variables: {id: id},
                                                                        });
    return response.data?.getApplicationScreenshot;
};

export const add = async (payload: Record<string, any>) => {
    const authentication = payload.authentication || await getAuthenticationInput();
    const response = await client.graphql<GraphQLQuery<CreateApplicationScreenshot>>({
                                                                               query: createApplicationScreenshot,
                                                                               variables: {input: {...payload, authentication}},
                                                                           });
    return response.data?.createApplicationScreenshot;
};

export const update = async (_id: string, record: ApplicationScreenshot) => {

    const authentication = record.authentication || await getAuthenticationInput();
    const input = {
        id: record.id,
        url: record.url,
        path: record.path,
        selector: record.selector,
        viewportWidth: record.viewportWidth,
        viewportHeight: record.viewportHeight,
        fullPage: record.fullPage,
        waitForSelector: record.waitForSelector,
        delay: record.delay,
        deviceScaleFactor: record.deviceScaleFactor,
        hideScrollbars: record.hideScrollbars,
        authentication,
    };

    const response = await client.graphql<GraphQLQuery<UpdateApplicationScreenshot>>({
                                                                               query: (updateApplicationScreenshot),
                                                                               variables: {input: input},
                                                                           });
    return response.data?.updateApplicationScreenshot;
};

export const retake = async (id: string) => {
    const authentication = await getAuthenticationInput();
    const response = await client.graphql<GraphQLQuery<RetakeApplicationScreenshot>>({
                                                                               query: retakeApplicationScreenshot,
                                                                               variables: {input: {id: id, authentication}},
                                                                           });
    return response.data?.retakeApplicationScreenshot;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteApplicationScreenshot>>({
                                                                               query: (deleteApplicationScreenshot),
                                                                               variables: {input: {id: id}},

                                                                           });
    return response.data?.deleteApplicationScreenshot;
};
